import NextLink from 'next/link';
import { cx } from '@onbeam/business-styled-system/css';
import { SubNavItemProps } from './SubNavItem.types';
import { subMenuStyles } from './SubNavItem.styles';
import { ArrowDiagonalIcon } from '@onbeam/icons/business';

export const SubNavItem = ({
  label,
  subLabel,
  href,
  icon: Icon,
  isExternal,
  variant,
  alwaysShowIcon,
  onClick,
}: SubNavItemProps) => {
  const subMenuClasses = subMenuStyles({ variant });

  const iconSize = variant === 'compact' ? 18 : 24;

  return (
    <NextLink
      key={href}
      href={href}
      target={isExternal ? '_blank' : '_self'}
      rel="noopener noreferrer"
      tabIndex={0}
      className={cx('subGroup', subMenuClasses.link)}
      onClick={onClick}
    >
      <div className={subMenuClasses.icon}>
        <Icon height={iconSize} width={iconSize} />
      </div>
      <div className={subMenuClasses.content}>
        <div className={subMenuClasses.label}>
          <span>{label}</span>
          <ArrowDiagonalIcon
            height={16}
            width={16}
            data-always-show-icon={alwaysShowIcon}
            className={subMenuClasses.arrow}
          />
        </div>
        <span className={subMenuClasses.subLabel}>{subLabel}</span>
      </div>
    </NextLink>
  );
};
